module.exports = __webpack_public_path__ + "images/horizontal-rectangle-d2a53186.svg";